import React, { useMemo } from 'react';
import { Chip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';

const DataQualityIndicator = ({ equityCurve }) => {
  const quality = useMemo(() => {
    if (!equityCurve || equityCurve.length === 0) {
      return { 
        level: 'none', 
        message: 'No data available', 
        color: 'error',
        icon: <WarningIcon fontSize="small" />
      };
    }
    
    if (equityCurve.length >= 100) {
      return { 
        level: 'excellent', 
        message: `${equityCurve.length} daily points - Excellent`, 
        color: 'success',
        icon: <CheckCircleIcon fontSize="small" />
      };
    } else if (equityCurve.length >= 50) {
      return { 
        level: 'good', 
        message: `${equityCurve.length} points - Good quality`, 
        color: 'info',
        icon: <InfoIcon fontSize="small" />
      };
    } else {
      return { 
        level: 'limited', 
        message: `${equityCurve.length} points - Limited data`, 
        color: 'warning',
        icon: <WarningIcon fontSize="small" />
      };
    }
  }, [equityCurve]);

  return (
    <Chip 
      label={quality.message}
      color={quality.color}
      size="small"
      icon={quality.icon}
      variant="outlined"
    />
  );
};

export default DataQualityIndicator;